import Form from './form';

export default Form.extend( {

    events: {
        'click .-add-edit-save'() {
            if (!this.validate())
                return;
            this.trigger( 'intermediate-property:add-edit-save',
                this.model.toJSON() );
        },

        'click .-add-edit-cancel'() {
            this.trigger( 'intermediate-property:add-edit-cancel' );
        },
    },

    validate() {
        this.$( '.form-group' ).removeClass( 'has-error has-warning' );
        const $errorsFound = this.$el.find( 'fieldset' ).filter( ':not(:disabled)' )
            .find( '.form-group' )
            .filter( (index, el) => this.$( el ).find( 'input, select, textarea' ).filter( ':invalid' ).length )
            .addClass( 'has-error' )
            .first();

        $errorsFound.find( 'input, select, textarea' )
            .focus();

        return !$errorsFound[0];
    },
    
    serialize() {
        return {
            title: this.options.title,
        };
    },
} );


// WEBPACK FOOTER //
// ./src/js/view/config.property.intermediate.form.js